export const RESET_STORE = "RESET_BATTLE_RESULTS_STORE";
export const UPDATE_BATTLE_RESULTS = "UPDATE_BATTLE_RESULTS";
export const UPDATE_BATTLE_INFO = "UPDATE_BATTLE_INFO";
export const UPDATE_COLUMN_SORT = "UPDATE_COLUMN_SORT";
export const SET_SELECTED_PERIOD_RESULT = "SET_SELECTED_PERIOD_RESULT";
